// extracted by mini-css-extract-plugin
export default {"page":"passwordResetPage_page__hoVYE"};